import React, { useState } from 'react';
import EngineVendorManagement from './EngineVendorManagement';
import EngineListAnalysis from './EngineListAnalysis';
import EngineUniqueAnalysis from './EngineUniqueAnalysis';
import EnginePriceMatrix from './EnginePriceMatrix';
import EngineOpistoSync from './EngineOpistoSync';
import './ImportHub.css';

const SUBTABS = [
  { key: 'vendeur-moteur', label: 'Vendeur (moteur)' },
  { key: 'analyse-liste', label: 'Analyse par liste' },
  { key: 'analyse-unique', label: 'Analyse unique' },
  { key: 'prix-moteur', label: 'Prix Moteur' },
  { key: 'synchro-opisto', label: 'Synchro Opisto' },
];

const MoteurImport = () => {
  const [active, setActive] = useState('vendeur-moteur');
  const activeTab = SUBTABS.find((tab) => tab.key === active);

  return (
    <div className="import-hub">
      <nav className="import-subtabs">
        {SUBTABS.map((tab) => (
          <button
            key={tab.key}
            className={`import-subtab-btn ${active === tab.key ? 'active' : ''}`}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className="import-subtab-content">
        {active === 'vendeur-moteur' ? (
          <EngineVendorManagement />
        ) : active === 'analyse-liste' ? (
          <EngineListAnalysis />
        ) : active === 'analyse-unique' ? (
          <EngineUniqueAnalysis />
        ) : active === 'prix-moteur' ? (
          <EnginePriceMatrix />
        ) : active === 'synchro-opisto' ? (
          <EngineOpistoSync />
        ) : (
          <div className="search-section">
            <h2>{activeTab?.label || 'Moteur'}</h2>
            <p>Onglet vide pour l'instant.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MoteurImport;
